<template>
  <span v-if="iso" :class="['fi', flag]" :title="title || iso"></span>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  const { iso, title = null } = defineProps<{
    iso: string
    title?: string
  }>()
  const flag = computed((): string => {
    return 'fi-' + iso.toLowerCase()
  })
</script>

<style scoped>
  .fi {
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;
    width: 1.3333em;
    line-height: 1em;
  }

  .fi::before {
    content: '\00a0';
  }

  .fi-nz {
    background-image: url('@/assets/flags/nz.svg');
  }

  .fi-au {
    background-image: url('@/assets/flags/au.svg');
  }
</style>
